'use strict';
require('../../../modules/es.string.starts-with');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('String', 'startsWith');
